import React, { memo } from 'react';
import { Target, Eye, Award } from 'lucide-react';

const cards = [
  {
    title: 'Missione',
    subtitle: 'Cosa facciamo',
    color: 'bg-brand-red',
    icon: Target,
    body: (
      <>
        <p>Vogliamo mettere al centro della nostra missione professionale l&rsquo;aiuto in situazioni dove l&rsquo;acqua ha provocato o sta provocando dei danni, alle cose o alla salute.</p>
        <p className="mt-3">Ci relazioniamo in modo concreto, veloce e umano con i nostri interlocutori.</p>
      </>
    ),
  },
  {
    title: 'Visione',
    subtitle: 'Dove vogliamo andare',
    color: 'bg-blue-500',
    icon: Eye,
    body: (
      <>
        <p>Garantiamo al cliente di anteporre il suo interesse al nostro e di dedicarci con competenza al progetto affidatoci.</p>
        <p className="mt-3">Mettiamo al servizio del cliente e dei nostri tecnici le giuste tecnologie per la gestione e risoluzione del problema.</p>
      </>
    ),
  },
  {
    title: 'Obiettivi',
    subtitle: 'Cosa vogliamo ottenere',
    color: 'bg-yellow-400',
    icon: Award,
    body: (
      <ul className="space-y-2 list-disc list-inside">
        <li>Evitare qualsiasi ulteriore danno infrastrutturale creato dall&rsquo;acqua</li>
        <li>Salvaguardare la salute del cliente dagli effetti dell&rsquo;umidità in eccesso</li>
      </ul>
    ),
  },
];

const Mission = () => {
  return (
    <section className="py-20 md:py-24 bg-brand-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: "linear-gradient(45deg, transparent 49%, white 50%, transparent 51%)",
        backgroundSize: '40px 40px'
      }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-white uppercase">La Nostra Missione</h2>
        <div className="w-20 h-1 bg-brand-red mx-auto mt-4" />

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.title} className="bg-brand-navy-light/60 backdrop-blur border border-white/10 rounded-xl p-7 hover:border-brand-red/50 transition-all hover:-translate-y-1">
                <div className={`w-14 h-14 ${c.color} rounded-lg flex items-center justify-center shadow-lg`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-display text-xl font-bold text-white uppercase tracking-wide mt-5">{c.title}</h3>
                <p className="text-sm italic text-white/60 mt-1">{c.subtitle}</p>
                <div className="mt-4 text-white/85 text-sm leading-relaxed">{c.body}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default memo(Mission);
